const ThemeActionTypes = {
	SET_THEME: "SET_THEME",
};

export default ThemeActionTypes;
